// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"X_dR","slider__element":"X_dS","itemSlider":"X_dT","itemSlider__slideWrapper":"X_dV","itemSlider__pagination":"X_dW","activeSlide":"X_dX"};